// Estado do menu lateral no desktop: expandido (260px, com rótulos), rail (72px,
// só ícones) ou oculto (0px, fora da tela). Persistido na chave que o menu já
// usava; os valores antigos ("1" = recolhido, "0" = expandido) continuam lidos.

export const CHAVE_MENU_LATERAL = "ag-festas.sidenav.v1";

// ids dos dois drawers do menu: os botões da TopBar os apontam em aria-controls
// (o desktop é o permanente; o do celular é o temporário aberto pelo hambúrguer).
export const ID_MENU_LATERAL = "menu-lateral";
export const ID_MENU_LATERAL_MOBILE = "menu-lateral-mobile";

export const MENU_EXPANDIDO = "expandido";
export const MENU_RAIL = "rail";
export const MENU_OCULTO = "oculto";

const ESTADOS = [MENU_EXPANDIDO, MENU_RAIL, MENU_OCULTO];

// "0"/"1" são os valores gravados antes de existir o estado oculto.
const LEGADO = { 0: MENU_EXPANDIDO, 1: MENU_RAIL };

const storagePadrao = () =>
  typeof window === "undefined" ? undefined : window.localStorage;

// localStorage pode lançar (modo privado, cookies bloqueados): sem leitura, o
// menu abre expandido.
export const lerEstadoMenu = (storage = storagePadrao()) => {
  try {
    const salvo = storage?.getItem(CHAVE_MENU_LATERAL);
    if (ESTADOS.includes(salvo)) return salvo;
    if (Object.hasOwn(LEGADO, salvo)) return LEGADO[salvo];
  } catch {
    // sem leitura
  }
  return MENU_EXPANDIDO;
};

export const gravarEstadoMenu = (estado, storage = storagePadrao()) => {
  try {
    storage?.setItem(CHAVE_MENU_LATERAL, estado);
  } catch {
    // sem persistência: o estado vale só nesta sessão
  }
};

// Um botão só percorre os três estados; o oculto volta ao expandido.
export const proximoEstadoMenu = (estado) => {
  if (estado === MENU_EXPANDIDO) return MENU_RAIL;
  if (estado === MENU_RAIL) return MENU_OCULTO;
  return MENU_EXPANDIDO;
};

// No celular o menu é o drawer temporário (aberto pelo hambúrguer): o estado do
// desktop não se aplica e o menu se comporta como rail, como sempre foi.
export const estadoEfetivoDoMenu = (estado, isMobile) =>
  isMobile ? MENU_RAIL : estado;

export const larguraDoMenu = (estado, { expandida, rail }) => {
  if (estado === MENU_OCULTO) return 0;
  return estado === MENU_RAIL ? rail : expandida;
};
